import { createClient } from '@supabase/supabase-js';

const PROJECT_URI = "https://lcrdvobffmnpucziqcwz.supabase.co"
const PROJECT_ANON ="eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImxjcmR2b2JmZm1ucHVjemlxY3d6Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3NjA1NDEyNjIsImV4cCI6MjA3NjExNzI2Mn0.UaDCB6p3FGX-W4iDMhPrRR9RnHWuIPA_Q-Z73iM85l0"

export const supabase = createClient(PROJECT_URI, PROJECT_ANON);